//
//  SDKWorkspaceNPMRegistryType.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Workspace subscription status internal enum
// Following are possible:   NPMJS, GitHub, AzureDevOps, Artifactory, Custom
export var WorkspaceNPMRegistryType;
(function (WorkspaceNPMRegistryType) {
    /** The workspace is configured to be able to access NPMJS registry */
    WorkspaceNPMRegistryType["npmJS"] = "NPMJS";
    /** The workspace is configured to be able to access GitHub registry */
    WorkspaceNPMRegistryType["gitHub"] = "GitHub";
    /** The workspace is configured to be able to access AzureDevOps registry */
    WorkspaceNPMRegistryType["azureDevOps"] = "AzureDevOps";
    /** The workspace is configured to be able to access Artifactory registry */
    WorkspaceNPMRegistryType["artifactory"] = "Artifactory";
    /** The workspace is configured to be able to access Custom registry */
    WorkspaceNPMRegistryType["custom"] = "Custom";
})(WorkspaceNPMRegistryType || (WorkspaceNPMRegistryType = {}));
